import React, { useState, useEffect } from "react";
import ViewIncoice from "../../../../../entities/DashboardPage/AccountingModule/Invoice/InvoiceView";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useLocation } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";
import { salaryService } from "../../../../../api";

const ViewInvoicePage = () => {
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const { item, page } = state || {};
  const { flag, id } = item || {};
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [invoiceData, setInvoiceData] = useState()
  const [cashReceipt, setCashReceipt] = useState(false)
  const [isPayslipAccessDisabled, setIsPayslipAccessDisabled] = useState(false);
  const role = localStorage.getItem("role");
  const isEmployeeRole = role === "Employee" || role === "employee";

  // Employee-only, UX affordance only (not a security control - see
  // CLAUDE.md §21). This screen is reachable directly by URL/state, so the
  // check is repeated here rather than trusted from the list screen that
  // navigated in. Real enforcement, if any, happens server-side.
  const checkPayslipAccess = async () => {
    try {
      const result = await AuthService.getProfileView();
      const profile = result?.data;
      if (!profile) return;
      const isRemoved = profile?.isActive === false;
      const empType = profile?.additionalInformation?.empType;
      const contractEnd = profile?.additionalInformation?.contractor?.end;
      const isContractExpired =
        empType === "contractor" && !!contractEnd && new Date(contractEnd).getTime() < Date.now();
      setIsPayslipAccessDisabled(isRemoved || isContractExpired);
    } catch (error) {
      // Cannot determine status - fail open (UX only, see note above).
    }
  };

  useEffect(() => {
    if (flag === "paylist") {
      if (isEmployeeRole) checkPayslipAccess();
      handleShowPdf();
    } else if (cashReceipt) {
      getReceiptView();
    } else {
      getViewInvoice();
    }
  }, [flag, cashReceipt]);

  useEffect(() => {
    getAllBanks()
    getInvoice("", "", page);
  }, [])

  const handleDownload = async () => {
    LoaderHelper.loaderStatus(true);

    setLoading(true)
    try {
      const result = await AuthService.handleDownloadInvoice(item?._id);
      if (!result) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const blob = new Blob([result], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.${"pdf"}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getViewInvoice = async () => {
    const result = await AuthService.getInvoiceView(item?._id);
    return { __html: result };
  };
  const sentInvoice = async () => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.sentInvoice(item?._id);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        getInvoice("", "", page);
        showAlert(result?.message, "success");
      } else {
        setLoading(false)
        LoaderHelper.loaderStatus(false);

        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
    }
  };

  const paidInvoice = async (payload) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.paidInvoice(
        item?._id, // invoiceId
        payload.bankId, // bankId
        payload.type, // type
        payload.date, // date
        payload.amount, // amount
        payload.reference // reference
      );
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        getInvoice("", "", page)
        showAlert(result?.message, "success");
      } else {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleDeleteTransaction = async (invoiceId, transactionId) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);
    try {
      const result = await AuthService.deleteInvoiceTransaction(invoiceId, transactionId);
      if (result?.success === true) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        getInvoice("", "", page);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleShowPdf = async () => {
    const result = await salaryService.showPdf(id);
    return { __html: result };
  };

  const handlePrintPayslip = () => {
    window.print();
  };

  const getAllBanks = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleGetAllCompanyBankAccount();
      if (result?.success) {
        setData(result?.data?.bankAccounts);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getInvoice = async (text, sort, page) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getInvoice(text, sort, page);
      if (result?.success) {
        const matchedInvoice = result?.data?.invoices?.find(invoice => invoice._id === item?._id);
        if (matchedInvoice) {
          setInvoiceData(matchedInvoice);
        }
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getReceiptView = async () => {
    const result = await AuthService.getReceiptView(invoiceData?.receiptId);
    return { __html: result };
  };

  const handleDownloadReceipt = async () => {
    LoaderHelper.loaderStatus(true);

    setLoading(true)
    try {
      const result = await AuthService.handleDownloadReceipt(invoiceData?.receiptId);
      if (!result) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const blob = new Blob([result], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.${"pdf"}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleSentReceipt = async () => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.handleSentReceipt(invoiceData?.receiptId);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        getInvoice("", "", page);
        showAlert(result?.message, "success");
      } else {
        setLoading(false)
        LoaderHelper.loaderStatus(false);

        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
    }
  };

  const updatePayment = async ({ invoiceId, transactionId, payload }) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.updateInvoicePayment({ invoiceId, transactionId, payload });
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        getInvoice("", "", page);
        showAlert(result?.message, "success");
      } else {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
      showAlert(error, "error");
    }
  }

  const handleExportPayslip = async (salaryId) => {
    if (!salaryId) {
      showAlert("Salary ID is required", "error");
      return;
    }

    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.exportPayslip(salaryId);

      if (!result) {
        LoaderHelper.loaderStatus(false);
        showAlert("Export failed", "error");
        return;
      }

      const blob = new Blob([result], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = window.document.createElement("a");
      link.href = url;
      link.setAttribute("download", `payslip_${salaryId}.pdf`);
      window.document.body.appendChild(link);
      link.click();
      window.document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      showAlert("Payslip exported successfully", "success");
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message || "Export failed", "error");
    }
  };

  return (
    <ViewIncoice handleDownload={handleDownload} invoiceData={invoiceData} getReceiptView={getReceiptView} cashReceipt={cashReceipt} setCashReceipt={setCashReceipt} handleDownloadReceipt={handleDownloadReceipt} getInvoice={getInvoice} handleSentReceipt={handleSentReceipt} item={invoiceData} data={data} loading={loading} getViewInvoice={getViewInvoice} sentInvoice={sentInvoice} paidInvoice={paidInvoice} handleShowPdf={handleShowPdf} flag={flag} updatePayment={updatePayment} handleDeleteTransaction={handleDeleteTransaction} handleExportPayslip={handleExportPayslip} id={id} handlePrintPayslip={handlePrintPayslip} isPayslipAccessDisabled={isEmployeeRole && isPayslipAccessDisabled} />
  )

}

export default ViewInvoicePage;
